import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import HomeHero from './components/HomeHero';
import HomeProblem from './components/HomeProblem';
import HomeSolution from './components/HomeSolution';
import HomeProducts from './components/HomeProducts';
import HomeApplications from './components/HomeApplications';
import HomeCTA from './components/HomeCTA';

export default function Home() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '聚量應用材料｜PQernel® 廢棄塑膠再生 · 循環經濟 · 低碳材料解決方案',
      en: 'PolyQ Applied Materials | PQernel® Plastic Waste Recycling · Circular Economy · Low-Carbon Materials',
      ja: '聚量応用材料 | PQernel® 廃プラスチック再生・サーキュラーエコノミー・低炭素材料ソリューション',
    },
    description: {
      zh: '聚量應用材料以 PQernel® 奈米技術，協助塑膠回收廠、造粒廠、製造商與品牌端，導入高比例再生塑料，實現循環經濟與淨零碳排目標。',
      en: 'PolyQ Applied Materials uses PQernel® nano-technology to help plastic recyclers, compounders, manufacturers, and brands adopt high recycled content plastics, achieving circular economy and net-zero carbon emission goals.',
      ja: '聚量応用材料はPQernel®ナノテクノロジーにより、プラスチックリサイクル業者・造粒業者・メーカー・ブランドが高再生材料比率プラスチックを導入し、サーキュラーエコノミーとネットゼロカーボン目標を達成できるよう支援します。',
    },
    keywords: {
      zh: '聚量應用材料, PQernel, PQMB, 廢棄塑膠再生, 塑膠回收, 再生塑料, rPET, rvPlastics, 循環經濟, 淨零碳排, ESG, 低碳材料, 環保科技材料, Plastics Reviving',
      en: 'PolyQ Applied Materials, PQernel, PQMB, plastic waste recycling, recycled plastics, rPET, rvPlastics, circular economy, net-zero carbon, ESG, low-carbon materials, Plastics Reviving',
      ja: '聚量応用材料, PQernel, PQMB, 廃プラスチック再生, プラスチックリサイクル, 再生プラスチック, rPET, rvPlastics, サーキュラーエコノミー, ネットゼロカーボン, ESG, 低炭素材料, Plastics Reviving',
    },
    path: '/',
    jsonLd: {
      '@type': ['Organization', 'WebSite'],
      name: '聚量應用材料股份有限公司',
      alternateName: 'PolyQ Applied Materials Co., Ltd.',
      url: (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://www.juuliang.com',
      description: (lang === 'en'
        ? 'PolyQ Applied Materials uses PQernel® nano-technology to help plastic recyclers, compounders, manufacturers, and brands adopt high recycled content plastics, achieving circular economy and net-zero carbon emission goals.'
        : lang === 'ja'
          ? '聚量応用材料はPQernel®ナノテクノロジーにより、プラスチックリサイクル業者・造粒業者・メーカー・ブランドの高再生材料比率導入を支援します。'
          : '聚量應用材料以 PQernel® 奈米技術，協助塑膠回收廠、造粒廠、製造商與品牌端，導入高比例再生塑料，實現循環經濟與淨零碳排目標。'),
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'TW',
      },
    },
  });

  return (
    <PageLayout>
      <HomeHero />
      <HomeProblem />
      <HomeSolution />
      <HomeProducts />
      <HomeApplications />
      <HomeCTA />
    </PageLayout>
  );
}